.show_table {
	margin-bottom: 16px;

	.table {
		width: 100%;
		border-collapse: collapse;
		font-size: 14px;

		td {
			padding: 0px 10px 5px 10px;
		}

		.first_td {
			font-weight: bold;
			text-align: left;
		}

		.last_td {
			text-align: right;
		}
	}
}

.graph {
	height: 200px;
}
